import { Select } from 'antd'
import { Label } from 'common/components/Label/Label'
import type {
  DiscountFormContext,
  DiscountTypeOption,
  PatientDefaultDiscount,
} from 'features/Procedure/state/procedure-api.type'

import styles from './discount-select.module.scss'
import { isDiscountDisabledForForm } from './discount-utils'

type DiscountSelectProps = {
  value: string | null
  onChange: (optionId: string | null) => void
  formContext: DiscountFormContext
  discountTypes: ReadonlyArray<DiscountTypeOption> | undefined
  patientDefaultDiscount: PatientDefaultDiscount | null | undefined
  disabledByBilling?: boolean
}

export const DiscountSelect = ({
  value,
  onChange,
  formContext,
  discountTypes,
  patientDefaultDiscount,
  disabledByBilling = false,
}: DiscountSelectProps) => {
  const disabledByPatientDefault = isDiscountDisabledForForm(patientDefaultDiscount, formContext)
  const disabled = disabledByBilling || disabledByPatientDefault

  const options =
    discountTypes?.map((d) => ({
      value: d.option_id,
      label: d.title,
    })) ?? []

  return (
    <div className={styles.container}>
      <Label label='Discount' className={styles.label} />
      <Select
        size='large'
        allowClear
        value={value ?? undefined}
        onChange={(next) => onChange(next ?? null)}
        options={options}
        disabled={disabled}
        placeholder='Select discount'
      />
    </div>
  )
}

type DiscountHelperTextProps = {
  patientDefaultDiscount: PatientDefaultDiscount | null | undefined
}

export const DiscountHelperText = ({ patientDefaultDiscount }: DiscountHelperTextProps) => {
  const parts: string[] = []
  if (patientDefaultDiscount?.discount_type?.title) {
    parts.push(patientDefaultDiscount.discount_type.title)
  }
  if (patientDefaultDiscount?.discount_category?.title) {
    parts.push(patientDefaultDiscount.discount_category.title)
  }
  if (parts.length === 0) return null
  return (
    <span className={styles.helper}>
      <span className={styles.helperLabel}>Pt&apos;s Global Discounts:</span> {parts.join(', ')}
    </span>
  )
}
